import { sendToElementIframe } from "./index";
import { fields } from "../config";

export function iOSFocusFix(listener) {
  // see: from https://stackoverflow.com/questions/52826005/workaround-for-ios-10-12-webkit-safari-chrome-iframe-focus-bug
  document.addEventListener("touchstart", listener);
}

export function forceBlurAllExcept(currentField) {
  fields
    .filter((field) => field !== currentField)
    .forEach((field) => sendToElementIframe(field, { message: "forceBlur" }));
}
